import React, { useEffect } from "react";

//Style
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import defaultClasses from "./createAccountPage.module.scss";
import UIkit from "uikit";

//Components
import SocialAuthentication from "@Components/SocialLogin/components/SocialAuthentication";
import { useCreateAccountPage } from "@magento/peregrine/lib/talons/CreateAccountPage/useCreateAccountPage";
import HeaderBasic from "../../components/HeaderBasic";
import CreateAccountFormComplete from "@overrides_venia/venia-ui/components/CreateAccount/createAccountFormComplete";

//Assets
import { useIntl } from "react-intl";
import { useAppContext } from "@overrides_venia/peregrine/context/app";
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";
import { useUserContext } from "@overrides_venia/peregrine/context/user";
import { useHistory } from "@magento/venia-ui/lib/drivers";
import Button from "@overrides_venia/venia-ui/components/Button";
import signupImg from "@Assets/images/login/signUp.png";
import { bgImage } from "@Src_main/utils/generalUtils";
import { useHeaderType } from "@overrides_venia/venia-ui/components/Header/header";
var CreateAccountPage = _ref => {
  var {
    classes,
    showHeader = true,
    isPage = false,
    isLandingPage = false,
    backFunction,
    isOffCanvas = false
  } = _ref;
  var [, {
    actions: {
      setPageLoading
    }
  }] = useAppContext();
  useHeaderType("hidden");
  var {
    isMobile
  } = useWindowSize();
  var [{
    isApp
  }] = useUserContext();
  var {
    formatMessage
  } = useIntl();
  var history = useHistory();
  var mergedClasses = mergeClasses(defaultClasses, classes);
  function goToLogin() {
    try {
      if (window.location.pathname.includes(formatMessage({
        id: "url.key.login"
      }))) {
        UIkit.offcanvas("#offcanvas-registration-dx").hide();
      } else {
        if (!isOffCanvas && !isMobile) {
          history.push(formatMessage({
            id: "url.key.login"
          }));
        } else {
          UIkit.offcanvas("#offcanvas-login-dx").show();
          var hiddenListener = function () {
            UIkit.offcanvas("#offcanvas-login-dx").show();
            UIkit.util.off('#offcanvas-registration-dx', 'hidden', hiddenListener);
          };
          UIkit.util.on('#offcanvas-registration-dx', 'hidden', hiddenListener);
        }
      }
    } catch (error) {
      console.error(error);
    }
  }
  var talonProps = useCreateAccountPage();
  var {
    initialValues,
    handleCreateAccount
  } = talonProps;
  var navigateBack = () => {
    var url = isApp ? formatMessage({
      id: "url.key.app.login"
    }) : formatMessage({
      id: "url.key.login"
    });
    history.push(url);
  };
  useEffect(() => {
    if (isPage) {
      setPageLoading(false);
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-flex-center uk-width-1-1 "
  }, !isMobile && !isOffCanvas && /*#__PURE__*/React.createElement("div", {
    className: "uk-flex uk-flex-center uk-width-1-2 uk-background uk-background-cover",
    style: {
      backgroundImage: bgImage(signupImg)
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "registration-container ".concat(isMobile ? "" : "uk-overflow-auto ", " ").concat(isOffCanvas || isMobile ? "uk-width-1-1" : "uk-width-1-2", " ").concat(mergedClasses.registration_container),
    style: {
      height: isOffCanvas ? "100dvh" : "auto"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "page-wrapper ".concat(mergedClasses.page_wrapper)
  }, showHeader ? /*#__PURE__*/React.createElement(HeaderBasic, {
    color: "black",
    title: formatMessage({
      id: "button.registration"
    }),
    path: "closeSignUp",
    extraStyle: "solidCream",
    backFunction: isLandingPage ? null : backFunction || navigateBack
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: "uk-container uk-padding-large-bottom ".concat(mergedClasses.container)
  }, /*#__PURE__*/React.createElement("h1", {
    className: "title ".concat(mergedClasses.title, " uk-text-uppercase")
  }, formatMessage({
    id: "registration.modal.title"
  })), /*#__PURE__*/React.createElement(SocialAuthentication, {
    mode: "below_login",
    isPopup: false,
    showCreateAccount: () => {},
    bottomSeparator: true,
    textSeparator: formatMessage({
      id: "book.table.form.continue"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "uk-text-muted uk-text-center uk-text-xsmall "
  }, /*#__PURE__*/React.createElement("span", null, formatMessage({
    id: "social.login.disclaimer"
  })))), /*#__PURE__*/React.createElement(CreateAccountFormComplete, {
    initialValues: initialValues,
    onSubmit: handleCreateAccount,
    isDisabled: false
  }), /*#__PURE__*/React.createElement("div", {
    className: "button-container_login uk-margin-top uk-margin-large-bottom"
  }, /*#__PURE__*/React.createElement("p", {
    className: "uk-text-center uk-text-muted uk-text-xsmall uk-margin-remove-bottom"
  }, formatMessage({
    id: "signin.label.yes.account"
  })), /*#__PURE__*/React.createElement(Button, {
    id: "headerSignInDesktop",
    color: "dark-green",
    fullScreen: true,
    type: "button",
    onClick: () => {
      goToLogin();
    }
  }, formatMessage({
    id: "button.login"
  })))))));
};
export default CreateAccountPage;